export default __webpack_public_path__ + "static/media/upload.afb0fa10.svg";